"use strict";
var React = require("react");
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var {
    Input
} = require("react-bootstrap");
var AuthStore = require("../../../stores/AuthenticationStore");
var CompanyStore = require("../../../stores/CompanyStore");
var CompanyActions = require("../../../actions/CompanyActions");
var _ = require("underscore");

var RoleForm = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
      var roles = CompanyStore.getState().roles;
      return {
        id: this.props.role && this.props.role.id || "",
        name: this.props.role && this.props.role.name || "",
        roles: roles,
        hasSubmitted: false,
        formValidation: {
          nameValid: false,
        }
      };
    },
    onSubmit() {
      if (this.state.name === '') {
        this.setState({
          hasSubmitted: true,
          formValidation: {
            nameValid: this.state.name !== '',
          },
        });
      } else {
        this.props.onHide();
        // Initialize role object.
        var newRole = {
          "name": this.state.name,
        };

        if (this.props.role) {
          // In edit mode
          // Create data object.
          var dataObject = {
            "id": this.state.id,
            "body": newRole
          }
          // Trigger an update request to the server.
          CompanyActions.updateRole(dataObject);
        } else {
          // In add mode
          // Trigger a create request to the server.
          CompanyActions.addRole(newRole);
        }
      }
    },
    render: function() {
      return (
        <div className="modal-body">
          <Input
            label="Nafn *"
            type="text"
            className={`${(this.state.hasSubmitted && !this.state.formValidation.nameValid) ? 'error' : ''}`}
            placeholder="Sláðu inn nafn"
            valueLink={this.linkState("name")}
          />
        </div>
      );
    }
});

module.exports = RoleForm;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Roles/RoleForm.js